<template>
  <div id="filter-dropdown" v-click-outside="hide">
    <button class="sc-btn" @click="showBox = !showBox" v-if="name">
      {{ name }}
    </button>
    <img
      src="/static/icons/iconfilterblack.svg"
      class="icon pointer"
      @click="showBox = !showBox"
      v-else
    />

    <div class="filter-box" v-if="showBox">
      <div class="header">
        {{ header }}
      </div>
      <div class="body">
        <div class="item" v-for="row in rows" :key="row.key">
          <label class="select-input" v-if="type === 'radio'">
            {{ row.value }}
            <input
              type="radio"
              :value="row.key"
              name="input"
              v-model="radioPicker"
            />
            <span class="checkmark radio"></span>
          </label>
          <label class="select-input" v-if="type === 'checkbox'">
            {{ row.value }}
            <input
              type="checkbox"
              :value="row.key"
              name="input"
              v-model="checkboxPicker"
            />
            <span class="checkmark checkbox"></span>
          </label>
        </div>
      </div>
      <div class="footer text-right">
        <a @click="submit()" class="pointer">ตกลง</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["rows", "type", "header", "name"],
  data() {
    return {
      showBox: false,
      radioPicker: "",
      checkboxPicker: []
    };
  },
  methods: {
    submit() {
      if (this.type === "radio") {
        this.$emit("filterSubmit", this.radioPicker);
      } else if (this.type === "checkbox") {
        this.$emit("filterSubmit", this.checkboxPicker);
      }
      this.showBox = false;
    },
    hide() {
      this.showBox = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.icon {
  height: 34px;
  width: 34px;
  border-radius: 50%;
  border: solid 1px #e0e0e0;
  padding: 6px;

  position: relative;
}
.sc-btn {
  height: 34px;
  border-radius: 5px;
  background: #fff;

  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: -0.1px;
  text-align: center;
  color: #000000;
}
.filter-box {
  position: fixed;
  padding: 15px;
  margin-top: 5px;
  z-index: 89;

  border: solid 1px #e0e0e0;
  border-radius: 5px;
  background: #fff;

  .header {
    font-size: 16px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: -0.1px;
    color: #000000;
    padding-bottom: 10px;
  }
  .body {
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;

    .item {
      font-size: 14px;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.36;
      letter-spacing: -0.1px;
      color: #000000;
    }
  }
  .footer {
    font-size: 16px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.38;
    letter-spacing: -0.1px;
    color: #e27024;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/helper/Dropdown.vue